module.exports = __webpack_public_path__ + "static/media/headset.4a43a3c6.png";